@if (available()) {
  @if (activated()) {
    <app-iara-floating-chat-panel />
  }

  <app-iara-floating-launcher [iaraOpen]="panel.isOpen()" (askIara)="onToggle()" />
}
